export default __webpack_public_path__ + "static/media/tick_icon.a1901263.png";